import React, {useContext, useState} from 'react';
import ModalContainer from "../../common/modal_container";
import Btn from "../../layout/Btn";
import Flex from "../../layout/Flex";
import {PrivateUser} from "../../../hooks/useUser";
import api from "../../../util/api";

import loginGirl from "../../../_asset/source/login-girl.png"
import {UserContext} from "../../../app/_root";
import swal from 'sweetalert';
import { Logo_1, Logo_2 } from '../../common/logo';

function LoginPopup({title}: {title: string}) {
    const [loginPopShow, setLoginPopShow] = useState<boolean>(false)

    return (
        <>
            <Btn className={"green"} onClick={e=>setLoginPopShow(true)}>{title}</Btn>
            <LoginModal loginPopShow={loginPopShow}
                        setLoginPopShow={setLoginPopShow}/>
        </>
    );
}

export default LoginPopup;


export function LoginModal({loginPopShow, setLoginPopShow}: {loginPopShow: boolean; setLoginPopShow: Function;}){
    const { MutateUser } = useContext(UserContext);
    const [submitting, setSubmitting] = useState<boolean>(false);

    async function handleAPIError(res: Response) {
        setSubmitting(false);
        const err: any = await res.json();
        swal({
            text: err,
            icon: "error",
        });
    }
    return (
        <ModalContainer show={loginPopShow}
                        setShow={setLoginPopShow}
                        closeBtn={true}
                        className={'login-pop'}
        >
            <main>
                <div className={'float-images'}>
                    <Logo_2 />
                </div>
                <div className={'modal-main'}>
                    <form action="/api/user/login"
                          onSubmit={e=> {
                              e.preventDefault();
                              setSubmitting(true);
                              const formData = new FormData(e.target as HTMLFormElement);
                              api('/api/user/login', { method: "POST", body: formData })
                                  .then(res => res.json())
                                  .then((data: PrivateUser) => {
                                      setSubmitting(false);
                                      MutateUser()
                                      setLoginPopShow(false)
                                  })
                                  .catch((error) => {
                                      handleAPIError(error)
                                  })
                          }}>
                        <p>로그인 후 이용 가능합니다.</p>
                        <div className={"login-row"}>
                            <input type="text" name={'username'} placeholder={`아이디`} autoCapitalize={"off"}/>
                        </div>
                        <div className={"login-row"}>
                            <input type="password" name={'password'} placeholder={`비밀번호`}/>
                        </div>

                        <Flex className={"btn-area"} gap={20}>
                            <button className={"new-login"} type={'submit'}>로그인</button>
                            {/*<Btn className={"register"} onClick={e=> {*/}
                            {/*    e.preventDefault()*/}
                            {/*    setLoginPopShow(false)*/}
                            {/*    SetRegisterPop()*/}
                            {/*}}>회원가입</Btn>*/}
                        </Flex>
                    </form>
                </div>
            </main>
        </ModalContainer>
    )
}